import {Injectable} from '@angular/core';
import {NetworkRest} from '../../../common/server-actions/network-rest';
import {of} from 'rxjs';
import {RequestOptions} from 'ac-infra';

@Injectable({providedIn: 'root'})
export class ExternalApplicationsRestService extends NetworkRest {

    constructor() {
        super({url: 'settings/externalApplications/arm/settings', entityType: 'external applications'});
    }

    public getLockedURL = (uri = undefined) => (ids, requestFiltered, fields?) => {
        if (requestFiltered && !ids) {
            return null;
        }

        const parameters: any = {detail: 1, limit: 100000};
        if (fields) {
            parameters.fields = fields;
        }

        if (ids) {
            parameters.filter = parameters.filter || {};
            parameters.filter.nodeId = ids;
        }

        return this.addFilterToURL(parameters, uri || 'status/externalApplications');
    };

    public getArmIp = (success, failure) => {
        this.get({skipPopulateFilter: true, build204JSON: false}).then(success).catch(failure);
    };

    public editArmIp = (armConnectionData, success, failure) => {
        this.put(success, failure, armConnectionData);
    };

    public getArmServerToken = (success, failure?) => {
        this.get({url: 'settings/externalApplications/arm/token', skipPopulateFilter: true, build204JSON: false}).then(success).catch(failure);
    };

    public getIAMToken = (success, failure, type, unitId) => {
        this.add(success, failure, {type, unitId}, 'settings/externalApplications/iam/token');
    };

    public getExternalEntityConfiguration = (type, success, failure) => {
        this.get({url: 'settings/externalApplications/' + type + '/settings', skipPopulateFilter: true, build204JSON: false}).then(success).catch(failure);
    };

    public editExternalEntityConfiguration = (vocaConfiguration, type, success, failure) => {
        this.put(success, failure, vocaConfiguration, 'settings/externalApplications/' + type +'/settings');
    };

    public getApplicationsStatuses = (success, failure) => of(this.get({
        url: 'status/externalApplications',
        skipPopulateFilter: true,
        build204JSON: false,
    }).then(success).catch(failure));

    public getApplicationsStatusesById = (ids, requestOptions: RequestOptions) => {
        const parameters = {filter: {nodeId: ids}};
        return this.get({url: 'status/externalApplications', skipPopulateFilter: true, extendParameters: true, build204JSON: false, parameters, ...requestOptions});
    };
}
